export default "__VITE_ASSET__BmcI3BPz__"